export const onlyDigits = (value) => (value || "").replace(/\D/g, "");

export const isValidCnpj = (value) => {
  const digits = onlyDigits(value);
  if (digits.length !== 14) return false;
  if (/^(\d)\1+$/.test(digits)) return false;

  const calcDigit = (base, weights) => {
    const sum = base
      .split("")
      .reduce((total, digit, index) => total + Number(digit) * weights[index], 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const base = digits.slice(0, 12);
  const firstDigit = calcDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calcDigit(
    base + firstDigit,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  return digits === base + String(firstDigit) + String(secondDigit);
};

const parseBrasilApi = (data) => ({
  razao_social: data.razao_social || data.nome || "",
  nome_fantasia: data.nome_fantasia || data.fantasia || "",
});

const parseCnpjWs = (data) => ({
  razao_social: data.razao_social || "",
  nome_fantasia: data.estabelecimento?.nome_fantasia || "",
});

const fetchBrasilApi = async (digits) => {
  const response = await fetch(
    `https://brasilapi.com.br/api/cnpj/v1/${digits}`
  );
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data.message || "Não foi possível consultar o CNPJ."
    );
    error.status = response.status;
    throw error;
  }

  return parseBrasilApi(data);
};

const fetchCnpjWs = async (digits) => {
  const response = await fetch(`https://publica.cnpj.ws/cnpj/${digits}`);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data.message || data.detail || "Não foi possível consultar o CNPJ."
    );
    error.status = response.status;
    throw error;
  }

  return parseCnpjWs(data);
};

export const fetchCnpjInfo = async (value) => {
  const digits = onlyDigits(value);

  if (digits.length !== 14) {
    throw new Error("CNPJ inválido. Informe os 14 dígitos.");
  }

  if (!isValidCnpj(digits)) {
    throw new Error("CNPJ inválido. Verifique os números informados.");
  }

  try {
    return await fetchBrasilApi(digits);
  } catch (primaryError) {
    const shouldTryFallback =
      !primaryError.status ||
      primaryError.status >= 500 ||
      primaryError.message === "Failed to fetch" ||
      primaryError.name === "TypeError";

    if (!shouldTryFallback) {
      throw primaryError;
    }

    try {
      return await fetchCnpjWs(digits);
    } catch (fallbackError) {
      if (primaryError.message === "Failed to fetch") {
        throw new Error(
          "Não foi possível conectar ao serviço de consulta. Verifique sua conexão ou desative bloqueadores e tente novamente."
        );
      }

      throw fallbackError;
    }
  }
};
